import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { LIMITED_WIDTH } from "app/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(6),
        margin: theme.spacing(4, 0),
        borderRadius: theme.borderRadius.default,
        backgroundColor: theme.palette.background.contrast,
        maxWidth: LIMITED_WIDTH,
    },

    text: {
        margin: 0,
    },
}));

export const SignupEarlyBirdNotice = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography variant="body1" className={classes.text}>
                We're currently tweaking our offerings, so you won't be charged until{" "}
                <strong>February 21st</strong>, at which point you'll have full access.
            </Typography>
        </div>
    );
};
